// function Feature({ name }) {
//   return (
//     <div className="flex p-2  rounded-md justify-center">
//       <button className="flex flex-col items-center gap-2 text-gray-500 hover:text-main transform hover:scale-125 transition-transform duration-150 ease-in-out">
//         <img
//           className="w-12 h-12 md:w-16 md:h-16"
//           src={`./icons/${name}.webp`}
//           alt={name}
//         />
//         <div className="tracking-wider text-center h-6 md:w-24 w-20 overflow-hidden">
//           {/* 使用 transform: scale 進行縮放 */}
//           <span className="inline-block ">{name}</span>
//         </div>
//       </button>
//     </div>
//   );
// }

// export default Feature;

function Feature({ name, onClick }) {
  return (
    <div className="flex p-2 rounded-md justify-center">
      <button
        onClick={onClick}
        className="flex flex-col items-center gap-2 text-gray-500 hover:text-main transform hover:scale-125 transition-transform duration-150 ease-in-out"
      >
        <img
          className="w-12 h-12 md:w-16 md:h-16"
          src={`./icons/${name}.webp`}
          alt={name}
        />
        <div className="tracking-wider text-center h-6 md:w-24 w-20 overflow-hidden">
          <span className="inline-block">{name}</span>
        </div>
      </button>
    </div>
  );
}

export default Feature;
